module.exports = __webpack_public_path__ + "static/background-hero-4913cb25d50c7404f0b60d73f1ea2adc.mp4";